module.exports = __webpack_public_path__ + "static/media/arrow-right.b772889e.svg";